import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useApp } from '../context/AppContext'
import { useAuth } from '../context/AuthContext'
import { getInitials } from '../data/mockData'

const eventNavItems = [
  { label: 'Samlet oversigt', path: '' },
  { label: 'Opgaver', path: '/todo' },
  { label: 'Tidsplan', path: '/tidsplan' },
  { label: 'Inventar', path: '/inventar' },
  { label: 'Budget', path: '/budget' },
  { label: 'Indkøbsliste', path: '/shopping' },
  { label: 'Gæsteliste', path: '/guests' },
  { label: 'Mad & Drikke', path: '/meals' },
  { label: 'Musik & Underholdning', path: '/musik' },
  { label: 'Transport & Kørsel', path: '/transport' },
  { label: 'Venues', path: '/venues' },
  { label: 'Filer', path: '/files' },
  { label: 'Team', path: '/team' },
]

export default function Sidebar({ onClose }) {
  const location = useLocation()
  const { events } = useApp()
  const { user } = useAuth()
  const [openEvents, setOpenEvents] = useState(() => {
    const eventId = location.pathname.match(/\/event\/([^/]+)/)?.[1]
    return eventId ? [eventId] : ['event-1']
  })
  const [eventColor, setEventColor] = useState('#6c63ff')

  const getSecondaryTextColor = (color) => {
    return '#222222'
  }

  const getNavBackground = (color) => {
    if (color === '#E8C1D1') return '#AE527D'
    return color
  }

  const getNavTextColor = (color) => {
    switch(color) {
      case '#E8C1D1': return '#CD0D6D'        // Blush Pink
      case '#B4B48D': return '#405727'        // Olive Green
      case '#C9845A': return '#8D5C3F'        // Dusty Rose (30% darker)
      case '#C08A4A': return '#D6852F'        // Terracotta → Burnt Orange
      case '#F7B98A': return '#AD8261'        // Apricot (30% darker)
      case '#2271B1': return '#184F7C'        // Blue (30% darker)
      default: return '#222222'
    }
  }

  const getProfileHoverColor = (color) => {
    return color + '4D'
  }

  useEffect(() => {
    const eventId = location.pathname.match(/\/event\/([^/]+)/)?.[1]
    if (eventId && events.length > 0) {
      const currentEvent = events.find(e => e.id === eventId)
      if (currentEvent) {
        setEventColor(currentEvent.color)
      }
    } else {
      setEventColor('#6c63ff')
    }
  }, [location.pathname, events])

  useEffect(() => {
    const eventId = location.pathname.match(/\/event\/([^/]+)/)?.[1]
    if (eventId && !openEvents.includes(eventId)) {
      setOpenEvents(prev => [...prev, eventId])
    }
  }, [location.pathname])

  const toggle = (id) => {
    setOpenEvents(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    )
  }

  const isActive = (path) => location.pathname === path

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="sb-logo" style={{ background: '#9B8B7A' }}>
        <div className="logo" style={{ color: '#ffffff' }}>Planora</div>
        <div className="logo-sub" style={{ color: '#ffffff' }}>Event planlægning</div>
      </div>

      <div className="sb-nav" style={{ background: '#9B8B7A', '--nav-text-color': getNavTextColor(eventColor) }}>
        <Link to="/dashboard" className={`sb-home-btn ${isActive('/dashboard') ? 'active' : ''}`} onClick={onClose}>
          <svg width="16" height="16" viewBox="0 0 14 14" fill="none">
            <path d="M1 7L7 1l6 6M2 6v6h4V9h2v3h4V6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Mit overblik
        </Link>

        <div className="sb-section-label">Mine events</div>

        {events.map(event => {
          const isOpen = openEvents.includes(event.id)
          return (
            <div key={event.id} className="ev-group">
              <div className={`ev-header ${isOpen ? 'open' : ''}`} onClick={() => toggle(event.id)} style={isOpen ? { fontWeight: 700, opacity: 1 } : undefined}>
                <span className="ev-name">{event.name}</span>
                <svg className={`ev-chevron ${isOpen ? 'open' : ''}`} viewBox="0 0 8 8" fill="none">
                  <path d="M2 3l2 2 2-2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
                </svg>
              </div>

              <div className={`ev-subnav ${isOpen ? 'open' : ''}`}>
                {eventNavItems.map(item => {
                  const href = `/event/${event.id}${item.path}`
                  const active = isActive(href)
                  return (
                    <Link
                      key={item.path}
                      to={href}
                      className={`sni ${active ? 'active' : ''}`}
                    >
                      {item.label}
                    </Link>
                  )
                })}
              </div>
            </div>
          )
        })}

        <Link to="/event/create" className="sb-add-event" onClick={onClose}>
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M5.5 1v9M1 5.5h9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          opret nyt event
        </Link>
      </div>

      <div className="sb-profile" style={{ background: '#9B8B7A', '--profile-hover-bg': '#8B7B6A' }}>
        <Link to="/profile" className="sb-profile-row sb-profile-active" onClick={onClose}>
          <div className="avatar" style={{ width: 30, height: 30, background: '#ffffff', color: getNavBackground(eventColor), fontSize: 11 }}>
            {getInitials(user?.displayName || 'Bruger')}
          </div>
          <div>
            <div className="sb-profile-name" style={{ color: '#ffffff' }}>{user?.displayName || 'Bruger'}</div>
            <div className="sb-profile-handle" style={{ color: '#ffffff' }}>{user?.email || ''}</div>
          </div>
        </Link>
      </div>
    </div>
  )
}
